import React from 'react';

const SupportingSignalsDrawer = ({ open, risk, onClose }) => {
  if (!open || !risk) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-stretch justify-end bg-black/50">
      <div className="h-full w-full max-w-xl border-l border-slate-700 bg-slate-950 p-4">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-xs uppercase tracking-wide text-slate-400">Supporting Signals</div>
            <h3 className="mt-1 text-lg font-semibold text-slate-100">{risk.title}</h3>
          </div>
          <button type="button" onClick={onClose} className="rounded-md border border-slate-700 px-2 py-1 text-sm text-slate-300 hover:bg-slate-800">
            Tutup
          </button>
        </div>

        <div className="mt-4 space-y-2">
          {(risk.supportingSignals || []).map((signal, idx) => (
            <div key={`${risk.riskId}-${idx}`} className="rounded-md border border-slate-800 bg-slate-900/80 px-3 py-2">
              <div className="text-xs text-slate-400">{signal.label || signal.key}</div>
              <div className="text-sm font-semibold text-slate-200">{String(signal.value ?? '-')}</div>
            </div>
          ))}
          {!(risk.supportingSignals || []).length ? (
            <div className="rounded-md border border-slate-800 bg-slate-900/80 px-3 py-2 text-sm text-slate-400">
              Belum ada supporting signal detail.
            </div>
          ) : null}
        </div>

        <div className="mt-4 rounded-md border border-slate-800 bg-slate-900/80 px-3 py-2 text-sm text-slate-300">
          <div className="text-xs text-slate-400">Rekomendasi</div>
          {risk.recommendedAction || '-'}
        </div>
      </div>
    </div>
  );
};

export default SupportingSignalsDrawer;
